import api from 'api';

const unwrap = (res) => res.data.data;

export const submitCoverage = async (alertId, url) =>
    (await api.post('/coverage-submissions', { alertId, url })).data;

export const fetchPendingCoverage = async ({ page = 1, size = 20 } = {}) =>
    unwrap(
        await api.get('/coverage-submissions/pending', {
            params: { page, size },
        })
    );

export const approveCoverage = async (id, { title, publisher }) =>
    unwrap(
        await api.post(`/coverage-submissions/${id}/approve`, {
            title,
            publisher,
        })
    );

export const rejectCoverage = async (id) =>
    (await api.delete(`/coverage-submissions/${id}`)).data;
